// import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Component, ViewChild, AfterViewInit, NgModule, Inject, OnInit} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { BrowserModule } from '@angular/platform-browser';
import { HttpService } from '../../http.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar} from '@angular/material/snack-bar';
import { AuthenticationService } from '../../_services';
import { EntradaService } from '../../_services';
import { first } from 'rxjs/operators';
import {MatButtonModule} from '@angular/material/button';
import { InvoiceService } from '../../_services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.scss']
})
export class InvoicesComponent implements OnInit {
  current_user: any;
  constructor(
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    this.asignarDatos();
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue

  }
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);
  }

}


@Component({
  selector: 'invoices-tab-1',
  templateUrl: './invoices-tab-1.html',
  styleUrls: ['./invoices.component.scss']

})
export class InvoicesTab1 implements AfterViewInit {

  displayedColumns: string[] = [
                                  'id',
                                  //'pagado',
                                  'fecha_emision',
                                  'fecha_vencimiento',
                                  'monto_base',
                                  'monto_iva',
                                  'monto_total',
                                  'status',
                                  'descargar'
                                ];
  entradaDatabase: EntradaDatabase | null;
  data: EntradaIssue[] = [];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  guiaForm: FormGroup;
  keywords = "";
  hay_datos = true;
  titulo_diff = false;
  datos_iniciales = true;


  constructor(
      private formBuilder: FormBuilder,
      private _httpClient: HttpClient,
      public dialog: MatDialog,
      private invoiceService: InvoiceService,
  ) { }

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;



  ngAfterViewInit() {


    this.entradaDatabase = new EntradaDatabase(this._httpClient);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    // console.log("las keywords iniciales son " + this.keywords)
    this.hacerTabla(this.keywords);



  }


  descargarInvoice(tipo, invoice_id){
    // console.log("vamos a descargar el invoice en " + tipo)
    this.invoiceService.invoice_url(invoice_id, tipo)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("la data es");
        // console.log(data);
        // console.log(data.status)
        // console.log(data.body["url"]);
        window.open(data.body["url"]);
      },
      error => {
       // this.error = error;
       // this.loading = false;
       // this.spinner = false;
    });
  }

  setClasses() {


    let myClasses = {
     // retrasado: Date.parse(fecha_corte.toISOString()) > Date.parse(fecha_creado),
     // a_tiempo: Date.parse(fecha_corte.toISOString()) < Date.parse(fecha_creado),
    }

    return  myClasses
  }

  hacerTabla(filtros){
    merge(this.sort.sortChange, this.paginator.page, )
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.entradaDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.pageIndex, filtros);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          // console.log("vamos en la 72")
          // console.log(data)
          if(data.items.length == 0) {
            this.hay_datos = false
            this.datos_iniciales = false
          }else{
            this.hay_datos = true
            this.datos_iniciales = true
          }


          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }

  mostrarCard(){
    if(this.datos_iniciales){
      this.titulo_diff = true;
    }else{
      this.titulo_diff = false;
    }
    this.hay_datos = !this.hay_datos;
  }


  //  PARA DIALOGO GUIAS
  openDialog(entrada_token) {
    // console.log("Entro a dialog guia")

    //// console.log(correo)
    const dialogRef = this.dialog.open(DialogInvoice ,{width:'450px', height: 'auto', data: {token: entrada_token}});

    dialogRef.afterClosed().subscribe(result => {
      // console.log("Cerramos el dialog");
      this.hacerTabla(this.keywords);
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywords = filterValue.trim().toLowerCase();
    // console.log("las keywords son ")
    // console.log(this.keywords)
    this.hacerTabla(this.keywords);
  }

}

export interface EntradabApi {
  items: EntradaIssue[];
  total_count: number;
}

export interface EntradaIssue {
  created_at: string;
  number: string;
  state: string;
  title: string;
}

/** An example database that the data source uses to retrieve data for the table. */
export class EntradaDatabase {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(sort: string, order: string, page: number, filtro: string): Observable<EntradabApi> {
    // console.log(sort)
    // console.log(order)
    // console.log(page)
     const href = `${environment.apiUrl}/rmsfe/query_invoices.json`;
    // const href = 'http://localhost:3000/rmsfe/query_entradas.json';
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}&keywords=${filtro}`;

    return this._httpClient.get<EntradabApi>(requestUrl);
  }
}



@Component({
  selector: 'invoices-tab-2',
  templateUrl: './invoices-tab-2.html',
  styleUrls: ['./invoices.component.scss']

})
export class InvoicesTab2 implements OnInit {

  displayedColumns: string[] = [
                                  'fecha',
                                  'tipo_transaccion',
                                  'categoria_transaccion',
                                  'numero',
                                  'canal',
                                  'aprobado_por',
                                  'saldo_antes',
                                  'valor_transaccion',
                                  'saldo_despues'

                                ];

  transactionDatabase: TransactionDatabase | null;
  data: TransactionIssue[] = [];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  guiaForm: FormGroup;
  keywords = "";
  hay_datos = true;
  titulo_diff = false;
  datos_iniciales = true;


  constructor(
      private formBuilder: FormBuilder,
      private _httpClient: HttpClient,
      public dialog: MatDialog,
  ) { }

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;



  ngAfterViewInit() {


    this.transactionDatabase = new TransactionDatabase(this._httpClient);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    // console.log("las keywords iniciales son " + this.keywords)
    this.hacerTablaInvoices(this.keywords);



  }

  ngOnInit() {
  }

  hacerTablaInvoices(filtros){
    merge(this.sort.sortChange, this.paginator.page, )
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.transactionDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.pageIndex, filtros);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          // console.log("vamos en la 72")
          // console.log(data)
          if(data.items.length == 0) {
            this.hay_datos = false
            this.datos_iniciales = false
          }else{
            this.hay_datos = true
            this.datos_iniciales = true
          }


          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }

  mostrarCard(){
    if(this.datos_iniciales){
      this.titulo_diff = true;
    }else{
      this.titulo_diff = false;
    }
    this.hay_datos = !this.hay_datos;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywords = filterValue.trim().toLowerCase();
    // console.log("las keywords son ")
    // console.log(this.keywords)
    this.hacerTablaInvoices(this.keywords);
  }

}

export interface TransactionApi {
  items: TransactionIssue[];
  total_count: number;
}

export interface TransactionIssue {
  created_at: string;
  number: string;
  state: string;
  title: string;
}

/** An example database that the data source uses to retrieve data for the table. */
export class TransactionDatabase {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(sort: string, order: string, page: number, filtro: string): Observable<TransactionApi> {
    // console.log(sort)
    // console.log(order)
    // console.log(page)
     const href = `${environment.apiUrl}/rmsfe/query_transactions.json`;
    // const href = 'http://localhost:3000/rmsfe/query_entradas.json';
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}&keywords=${filtro}`;

    return this._httpClient.get<TransactionApi>(requestUrl);
  }
}


@Component({
  selector: 'invoices-tab-3',
  templateUrl: './invoices-tab-3.html',
  styleUrls: ['./invoices.component.scss']

})
export class InvoicesTab3 implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}


@Component({
  selector: 'dialog-invoice',
  templateUrl: './dialog-invoice.html',
})
export class DialogInvoice {

  guiaForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error: string;
  la_guia: string;
  mensaje_success = false;
  guiaFormGuia: FormControl;
  formPaqueteria: FormControl;
  paqueteriaFormGuia: FormControl;
  spinner = false;
  entrada_token: string;
  keywords = "";
  otra = false;
  paqueteria: string;

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogInvoice>,
    private entradaService: EntradaService,
    @Inject(MAT_DIALOG_DATA) public data: any
    ){
    if(this.data.token){
      this.entrada_token = this.data.token;
      // console.log("El token es "+this.entrada_token);
    }
  }

  ngOnInit(){
    this.guiaForm = this.formBuilder.group({
      guiaFormGuia: ['', Validators.required],
    });

    this.guiaFormGuia = new FormControl('', [
      Validators.required,
    ]);

    this.formPaqueteria = new FormControl('', [
      Validators.required,
    ]);

    this.paqueteriaFormGuia = new FormControl('', [Validators.required]);
  }

  seleccionar(){
    if(this.formPaqueteria.value == "otro"){
      this.otra = true;
    }else{
      this.otra = false;
    }
  }

  guardarGuia(){
    if (this.guiaFormGuia.invalid || this.formPaqueteria.invalid || (this.otra && this.paqueteriaFormGuia.invalid)){
      // console.log("campos invalidos");
      return;
    }
    this.loading = true;
    this.spinner = true;

    this.mensaje_success = true;
    this.loading = false;
    this.spinner = false;

    // console.log(this.guiaFormGuia.value)
    // console.log(this.formPaqueteria.value)
    if(this.otra){
      this.paqueteria = this.paqueteriaFormGuia.value;
    }else{
      this.paqueteria = this.formPaqueteria.value;
    }
    this.entradaService.actualizarEntrada(this.entrada_token, this.guiaFormGuia.value, this.paqueteria)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("la data es");
        // console.log(data);
        // console.log(data.status)
        // console.log(data.body["message"]);
        if(data.status == 200){
          this.mensaje_success = true;
          this.loading = false;
          this.spinner = false;
        }else{
          this.error = data.body["message"];
          this.loading = false;
          this.spinner = false;
        }
      },
      error => {
        this.error = error;
        this.loading = false;
        this.spinner = false;
   });
  }

}
